<template>
  <navbar
    position="fixed"
    type="white"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
    :isPanzi="true"
    
  >
    <template >
      <router-link v-popover:popover1 class="navbar-brand" to="/panzi2023" style="  font-size: 0.875em;">
        Leonardo <font-awesome-icon icon="heart" class=" fa-beat" style="color:#f8dd7d
;"/> Martina <font-awesome-icon icon="heart" class=" fa-beat" style="color:#f8dd7d
;" /> Angelo Francesco
      </router-link>
      <el-popover
        ref="popover1"
        popper-class="popover"
        placement="bottom"
        width="200"
        trigger="hover"
      >
        <div class="popover-body">
          {{$t('chiara_home_popover')}}
        </div>
      </el-popover>
    </template>
    <template slot="navbar-menu">
      
      <!--  <li class="nav-item">
        <a class="nav-link" href="#rsvp">{{$t('rsvp')}} <font-awesome-icon icon="edit"  /></a>
      </li>
      <drop-down tag="li" v-bind:title ="$t('info')">
        <nav-link class="dropdown-item ">
          <a  href="#where" class="text-primary" ><i class="now-ui-icons location_pin text-primary" ></i> {{$t('whereWhen')}} </a>
        </nav-link>
        <nav-link class="dropdown-item">
          <a  href="#how" class="text-primary" ><i class="now-ui-icons location_compass-05"></i> {{$t('how')}}</a>
        </nav-link>
        <nav-link class="dropdown-item">
          <a  href="#video" class="text-primary" ><font-awesome-icon icon="video"  class="video"/>&nbsp; {{$t('sleep')}}</a>
        </nav-link>
        <nav-link class="dropdown-item">
          <a  href="#what" class="text-primary" ><font-awesome-icon icon="gifts"  class="bed text-primary"/>&nbsp; {{$t('gift')}}</a>
        </nav-link>
      </drop-down>
      <drop-down tag="li" v-bind:title="$t('extra')">
        <nav-link class="dropdown-item">
          <i class="now-ui-icons media-1_camera-compact"></i>{{$t('visit')}}
        </nav-link>
         <nav-link class="dropdown-item">
          <font-awesome-icon icon="snowflake"  class="bed"/>&nbsp;{{$t('forecast')}}
        </nav-link>
      </drop-down> -->
      <!--  <li class="nav-item">
        <a class="nav-link" href="#">{{$t('contact')}}&nbsp;<font-awesome-icon icon="comment-alt"/></a>
      </li> -->
  
      <li class="nav-item">
        <a class="nav-link" href="#lista" style="color:black;  font-size: 0.875em;"><span class="panzi-gift"><font-awesome-icon icon="gift"/></span>&nbsp;{{$t('chiara_intro_title')}}</a>
      </li>
      <li class="nav-item" v-for="entry in languages" :key="entry.title" >
       <a class="nav-link" @click="changeLocale(entry.language)" style="color:black;">
                <flag :iso="entry.flag" v-bind:squared=false /> {{entry.title}}</a>
        
      </li>
    </template>
  </navbar>
</template>

<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';
import { Popover } from 'element-ui';
import i18n from '@/plugins/i18n';
export default {
  name: 'main-navbar',
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover
  },
   props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  data(){
    return { languages: [
                    { flag: 'it', language: 'it', title: this.$t('it_lang') },
                    { flag: 'cz', language: 'cz', title: this.$t('cz_lang') }
                ]
   
    }


  },
  methods: {
            changeLocale(locale) {
                i18n.locale = locale;
            }
        }
};
</script>

<style scoped>
.bed{
  color:grey;
}
.fa-beat {
  -webkit-animation: fa-beat 1s infinite linear;
  animation: fa-beat 1s infinite linear;
  color: red;
}
@-webkit-keyframes fa-beat {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes fa-beat {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>
